import { useAgentPlatformConnections } from "@/pages/DeploymentsPage/application/useAgentPlatform"
import { AgentCoreSettingsModal } from "@/pages/DeploymentsPage/components/organisms/AgentCoreCloudConnection"
import { ConnectionSettingsState } from "./ConnectionSettingsState"

import type { PlatformSettingsProps } from "../CloudConnectionSettings.types"

// An AWS account's settings, from its row
export const AgentCoreSettings = (props: PlatformSettingsProps) => {
  const connections = useAgentPlatformConnections("agentcore")

  return (
    <ConnectionSettingsState {...connections} {...props}>
      {(connection) => (
        <AgentCoreSettingsModal
          connection={connection}
          onClose={props.onClose}
        />
      )}
    </ConnectionSettingsState>
  )
}
